import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.205 13.6524c.4907-.2534 1.0939-.0611 1.3473.4296l3.336 6.459c.2534.4907.0611 1.094-.4296 1.3474s-1.094.0611-1.3474-.4296l-3.3359-6.459c-.2535-.4907-.0611-1.0939.4296-1.3474",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15.6999 14.2801c.1429-.5335.6913-.8501 1.2247-.7071l4.2051 1.1267c.5334.1429.85.6913.7071 1.2247-.143.5335-.6913.8501-1.2248.7071l-4.205-1.1267c-.5335-.1429-.85-.6913-.7071-1.2247",
        clipRule: "evenodd"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.9245 13.5729c.5335.1429.8501.6912.7071 1.2247l-1.1267 4.205c-.143.5335-.6913.8501-1.2248.7071-.5334-.1429-.85-.6912-.7071-1.2247l1.1268-4.205c.1429-.5335.6912-.8501 1.2247-.7071",
        clipRule: "evenodd"
    }, "2"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-500, #666666)",
        fillRule: "evenodd",
        d: "M12 3c-4.4183 0-8 3.5817-8 8s3.5817 8 8 8c.5523 0 1 .4477 1 1s-.4477 1-1 1C6.4772 21 2 16.5228 2 11S6.4772 1 12 1s10 4.4772 10 10c0 .5523-.4477 1-1 1s-1-.4477-1-1c0-4.4183-3.5817-8-8-8",
        clipRule: "evenodd"
    }, "3"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-500, #666666)",
        fillRule: "evenodd",
        d: "M2.5996 8c0-.5523.4477-1 1-1h16.8c.5523 0 1 .4477 1 1s-.4477 1-1 1h-16.8c-.5523 0-1-.4477-1-1M3 14c0-.5523.4477-1 1-1h8.5c.5523 0 1 .4477 1 1s-.4477 1-1 1H4c-.5523 0-1-.4477-1-1",
        clipRule: "evenodd"
    }, "4"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-500, #666666)",
        fillRule: "evenodd",
        d: "M12.0291 1.1518c.4685.2924.6113.9092.3189 1.3778a16 16 0 0 0 0 16.9411c.2924.4686.1496 1.0854-.3189 1.3778s-1.0854.1496-1.3778-.319a18 18 0 0 1 0-19.0588c.2924-.4685.9092-.6113 1.3778-.319",
        clipRule: "evenodd"
    }, "5"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-500, #666666)",
        fillRule: "evenodd",
        d: "M11.9706 1.1518c.4685-.2924 1.0854-.1496 1.3778.319A18 18 0 0 1 16.0778 11c0 .5523-.4477 1-1 1s-1-.4477-1-1c0-2.995-.8406-5.9297-2.4262-8.4705-.2923-.4686-.1495-1.0854.319-1.3778",
        clipRule: "evenodd"
    }, "6")
], "ChannelWeb", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
